export default '6.0.1';
